"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const ListNumber = (props) => {
  const _a = props, { className, size = IconSize.Medium, color = "inherit" } = _a, rest = __objRest(_a, ["className", "size", "color"]);
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    __spreadValues({ width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass }, rest),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        d: "M4.97 4.316h-.648l-1.146.546v.912l.858-.414V8h.936V4.316zm-.45 7.146c0 .216-.168.402-.42.66l-1.266 1.26V14h2.67v-.828H4.178l.606-.6c.372-.36.708-.696.708-1.17 0-.684-.51-1.146-1.32-1.146-.786 0-1.284.546-1.356 1.23h.996c.012-.198.132-.366.36-.366.216 0 .348.144.348.342zm-.396 7.02h-.228v-.69h.198c.264 0 .468-.114.468-.372 0-.204-.138-.36-.372-.36-.258 0-.402.186-.426.408H2.84c.078-.666.57-1.212 1.38-1.212.774 0 1.254.462 1.254 1.128 0 .318-.174.63-.402.756.294.138.45.438.45.774 0 .654-.498 1.146-1.308 1.146-.846 0-1.38-.498-1.428-1.242h.96c.024.252.174.432.45.432.24 0 .408-.15.408-.384 0-.252-.198-.384-.48-.384zM8 5h14v2H8V5zm0 6h14v2H8v-2zm10 6H8v2h10v-2z",
        clipRule: "evenodd"
      }
    )
  );
};
export default ListNumber;
